import { render, staticRenderFns } from "./IdpCallback.vue?vue&type=template&id=1154d039&scoped=true&"
import script from "./IdpCallback.vue?vue&type=script&lang=js&"
export * from "./IdpCallback.vue?vue&type=script&lang=js&"
import style0 from "./IdpCallback.vue?vue&type=style&index=0&id=1154d039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154d039",
  null
  
)

export default component.exports